<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import Checkbox from 'svelte-checkbox';
    import Modal from '../modal/modal.svelte';

    import iosFullScreenStep1 from '@src/assets/img/ios_fullscreen_step1.webp';
    import iosFullScreenStep2 from '@src/assets/img/ios_fullscreen_step2.webp';

    const dispatch = createEventDispatcher();

    export let skipFullScreenModal;
</script>

<Modal isOpen={true} maxWidth={450}>
    <div class="wrapper mx-2">
        <div class="content">
            <h2 class="title">Before we start</h2>
            <span> Your can hide Safari Toolbar for a better experience by a few simple steps: </span>
            <ul>
                <li>
                    <span class="counter"> 1 </span>
                    Tap <b>aA</b> in address bar
                    <img src={iosFullScreenStep1} alt="step1" />
                </li>
                <li>
                    <span class="counter"> 2 </span>
                    Tap <b>“Hide Toolbar”</b> in menu
                    <img src={iosFullScreenStep2} alt="step2" />
                </li>
            </ul>

            <button
                class="btn-base btn-accept w-40 rounded-full py-3 font-Roboto text-md font-bold uppercase text-white hover:cursor-pointer"
                on:click={() => dispatch('close')}
            >
                Got it
            </button>
            <div class="flex items-center justify-center gap-2">
                <Checkbox
                    class="main__checkbox"
                    checked={skipFullScreenModal || false}
                    name="show-again"
                    on:change={() => dispatch('skip-again', !skipFullScreenModal)}
                    primaryColor="#fff"
                    secondaryColor="#000000"
                />

                <label for="show-again" class="text-xs font-bold uppercase text-white">do not show again </label>
            </div>
        </div>
    </div>
</Modal>

<style>
    .wrapper {
        color: #cccccc;
        min-height: 180px;
        padding: 24px 16px;
        text-align: center;
        font-size: 14px;
        line-height: 16px;
        background: #292929;
        border-radius: 16px;
        font-family: 'Roboto Condensed', serif;
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        place-items: center;
        flex-wrap: nowrap;
        flex-shrink: 0;
        flex-grow: 0;
        position: relative;
        gap: 16px;
    }

    .title {
        font-weight: 700;
        font-size: 24px;
        line-height: 100%;
        margin-bottom: 24px;
        color: white;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    ul li {
        margin-bottom: 16px;
    }

    ul li .counter {
        width: 24px;
        height: 24px;
        display: inline-block;
        border-radius: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        place-items: center;
        flex-wrap: nowrap;
        flex-shrink: 0;
        flex-grow: 0;
        display: inline-flex;
        margin-right: 8px;
        content: counter(steps);
        color: black;
        background: #eeeeee;
    }

    ul li img {
        margin: 8px 0;
        max-width: 190px;
        display: block;
    }

    .btn-accept {
        background: linear-gradient(90deg, #01378c 0%, #1f77ff 100%);
        box-shadow: 0px 6px 6px 0px #000a1a80;
    }
</style>
